import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AccountAction } from 'dashboard/models/account-action';

export interface AccountActionState {
  accountAction: AccountAction | undefined;
}

export const initialState: AccountActionState = {
  accountAction: undefined,
};

interface SetAccountActionPayload {
  accountAction: AccountAction | undefined;
}

/**
 * The following ts-ignore gets us around a bug with immer.js where its Draft type doesn't handle recursive types
 * such as our Field type which references itself. The path to the offending type is Case -> FieldsMap -> Field.
 * We should be able to remove this ts-ignore after this issue is addressed: https://github.com/immerjs/immer/issues/839
 * */

/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
const { reducer, actions } = createSlice({
  name: 'account-action',
  initialState,
  reducers: {
    clearAccountAction: () => {
      return initialState;
    },
    setAccountAction: (state, action: PayloadAction<SetAccountActionPayload>) => {
      state.accountAction = action.payload.accountAction;
    },
  },
});

export const { clearAccountAction, setAccountAction } = actions;

export const accountActionReducer = reducer;
